import { useTranslation } from '@sm360/hooks'
import { updateDrCalculatorStart } from '@sm360/helpers'
import { Card, CardSection, Icon, InputCurrency, Modal } from '@sm360/ui-library'
import React from 'react'

import { getQuoteDeskingPaymentOptions } from '../../../apis/showroom/showroom.service'
import { Context } from '../../../configs/state.manager'
import { payloadPaymentOptionsTransform } from '../../../transforms/payloadPaymentOptions.transform'

const CashCard = () => {
    const {
        state,
        state: {
            dealerInfos: { lang },
            paymentOptions: { cashPurchase, tradeIn, lien, disclaimer },
            vehicle,
            quoteId,
        },
        dispatch,
    } = React.useContext(Context)

    const { t } = useTranslation()

    const handleChange = async (value) => {
        try {
            const payload = payloadPaymentOptionsTransform({ state, ...value })
            const initPaymentOptions = await getQuoteDeskingPaymentOptions(payload)

            updateDrCalculatorStart(quoteId, vehicle, 'cash')

            dispatch({ type: 'setPaymentOptions', paymentOptions: initPaymentOptions.data })
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <div className='pc-cashCard'>
            <Card className='pc-cashCard__wrapper'>
                <CardSection className='pc-cashCard__section'>
                    <div className='pc-cashCard__title'>{t('pc.cash')}</div>

                    <InputCurrency
                        id='sellingPrice'
                        name='sellingPrice'
                        className='pc-cashCard__sellingPrice'
                        value={cashPurchase?.sellingPrice}
                        displayAsText
                        displayWithTwoDecimals
                        locale={lang}
                    />

                    <Modal
                        modalTitle=''
                        trigger={
                            <span>
                                <Icon name='info-circle' className='pc-leaseCard__icon' />
                            </span>
                        }
                        className='pc-modal__inner'
                    >
                        <div className='pc-disclaimer'>{disclaimer}</div>
                    </Modal>

                    <div className='pc-cashCard__sellingPriceLabel'>{t('pc.sellingPrice')}</div>

                    <InputCurrency
                        id='tradeIn'
                        name='tradeIn'
                        className='pc-cashCard__input pc-cashCard__tradeIn'
                        label={t('pc.tradeInEstimate')}
                        value={tradeIn}
                        onChange={(v) => handleChange({ tradeIn: v })}
                        locale={lang}
                    />

                    <InputCurrency
                        id='lien'
                        name='lien'
                        className='pc-cashCard__input pc-cashCard__lien'
                        label={t('pc.lien')}
                        value={lien}
                        onChange={(v) => handleChange({ lien: v })}
                        locale={lang}
                    />
                </CardSection>
            </Card>
        </div>
    )
}

export default CashCard
